// extracted by mini-css-extract-plugin
export default {"container":"PredictionsFragment_container__c2sYC"};